export type BuyerAppDeepLinkKind = 'product' | 'seller';

export const BuyerAppDeepLinkConfig: Record<
  BuyerAppDeepLinkKind,
  { documentTitle: string; shareButtonLabel: string }
> = {
  product: {
    documentTitle: '打开圆领商品',
    shareButtonLabel: '若未下载点此下载APP',
  },
  seller: {
    documentTitle: '打开圆领卖家',
    shareButtonLabel: '若未下载点此下载APP',
  },
};
